import { Link } from "react-router-dom";
import { branchesSummary, dashboardStats } from "@/mocks/dashboard";
import { formatSAR } from "@/utils/format";

export default function BranchesRow() {
  const activeBranches = branchesSummary.filter((branch) => branch.isActive);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <div className="yc-fade-up yc-card-hover lg:col-span-2 bg-white rounded-card border border-background-200 shadow-card p-5">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
              <i className="ri-map-pin-line"></i>
            </span>
            <h3 className="text-base font-bold text-foreground-950">
              الفروع النشطة
            </h3>
          </div>
          <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-800">
            {activeBranches.length} فروع
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {branchesSummary.map((branch) => (
            <div
              key={branch.id}
              className="flex items-center justify-between rounded-btn border border-background-200 px-4 py-3"
            >
              <div className="flex items-center gap-2.5 min-w-0">
                <span
                  className={`w-2 h-2 rounded-full shrink-0 ${
                    branch.isOpen ? "bg-primary-500" : "bg-secondary-300"
                  }`}
                ></span>
                <span className="text-sm font-medium text-foreground-800 truncate">
                  {branch.name}
                </span>
              </div>
              <span
                className={`text-xs font-medium whitespace-nowrap ${
                  !branch.isActive
                    ? "text-red-500"
                    : branch.isOpen
                      ? "text-primary-600"
                      : "text-foreground-400"
                }`}
              >
                {!branch.isActive
                  ? "معطّل"
                  : branch.isOpen
                    ? "مفتوح"
                    : "مغلق"}
              </span>
            </div>
          ))}
        </div>

        <Link
          to="/branches"
          className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700"
        >
          إدارة الفروع
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-left-s-line"></i>
          </span>
        </Link>
      </div>

      {dashboardStats.cashEnabled && (
        <div
          className={`yc-fade-up yc-card-hover rounded-card border shadow-card p-5 ${
            dashboardStats.cashDebt > 0
              ? "bg-red-50 border-red-200"
              : "bg-white border-background-200"
          }`}
        >
          <div className="flex items-center gap-2 mb-4">
            <span
              className={`w-8 h-8 flex items-center justify-center rounded-full ${
                dashboardStats.cashDebt > 0
                  ? "bg-red-100 text-red-600"
                  : "bg-primary-100 text-primary-700"
              }`}
            >
              <i className="ri-wallet-3-line"></i>
            </span>
            <h3 className="text-base font-bold text-foreground-950">
              رصيد رسوم التطبيق المستحقة لطلبات الكاش
            </h3>
          </div>

          <p
            className={`text-[32px] font-bold leading-none ${
              dashboardStats.cashDebt > 0
                ? "text-red-600"
                : "text-foreground-950"
            }`}
          >
            {formatSAR(dashboardStats.cashDebt)}
          </p>

          {dashboardStats.cashDebt > 0 ? (
            <>
              <p className="mt-3 text-xs leading-6 text-red-600/90">
                رسوم التطبيق المستحقة لطلبات الكاش — يجب سدادها لإعادة تفعيل
                استقبال الطلبات النقدية.
              </p>
              <Link
                to="/financial/settle"
                className="mt-4 inline-flex w-full h-10 items-center justify-center rounded-btn bg-red-500 text-white text-sm font-semibold hover:bg-red-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                سداد الآن
              </Link>
            </>
          ) : (
            <p className="mt-3 text-xs leading-6 text-foreground-500">
              لا توجد رسوم مستحقة حاليًا. الدفع النقدي مفعّل.
            </p>
          )}
        </div>
      )}
    </div>
  );
}